// const baseUrl = 'http://182.70.246.252:8080/v1'
// const baseUrl = 'http://localhost:4002/v1'
const baseUrl = 'http://mp555.cgwbdwlr.in/v1'

export default baseUrl
